import { render } from "./DropDown.vue?vue&type=template&id=35c8963c&scoped=true&ts=true"
import script from "./DropDown.vue?vue&type=script&lang=ts"
export * from "./DropDown.vue?vue&type=script&lang=ts"

import "./DropDown.vue?vue&type=style&index=0&id=35c8963c&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c8963c"]])

export default __exports__